import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import simplePopover from 'simple-popover';

Component('tr-subscriptions-form', {
  mixins: [eventListenerMixin],

  properties: {
    updateUrl: {
      type: String,
    },
  },

  ready() {
    const link = this.querySelector('#link-show-qrcode');
    this.listenTo(link, 'click', () => {
      simplePopover({
        pointTo: $(link),
        position: 'bottom-center',
        cls: 'upgrade-contact-popover',
        content: `<img src="${link.dataset.qrcode}"><p>手机号：18628252970</p>`,
      });
    });

    this.listenTo(this, 'change', (event) => {
      const { name, value } = event.target;
      if (name.includes('spec_id')) {
        this.requestData();
      } else if (name.includes('duration_months')) {
        this.requestData();
      } else if (name.includes('payment_method')) {
        const contact = this.querySelector('.form-contact');
        contact.classList.toggle('hide', value !== 'brohao');
        this.requestData();
      }
    });

    this.listenTo(this, 'tr-combo-select-field:change', () => {
      this.requestData();
    });

    this.requestData();
  },

  requestData() {
    if (this.request) this.request.abort();

    let spec = this.querySelector('[name*="spec_id"]:checked');
    let members = this.querySelector('#teams_subscriptions_form-members_limit tr-combo-select-field');
    let duration = this.querySelector('[name*="duration_months"]:checked');
    const method = this.querySelector('[name*="payment_method"]:checked').value;
    spec = spec ? spec.value : null;
    members = members ? members.getValue() : null;
    duration = duration ? duration.value : null;

    this.request = $.ajax({
      url: this.updateUrl,
      method: 'get',
      dataType: 'script',
      data: {
        'teams_subscriptions_form[spec_id]': spec,
        'teams_subscriptions_form[members_limit]': members,
        'teams_subscriptions_form[duration_months]': duration,
        'teams_subscriptions_form[payment_method]': method,
      },
    });
  },

  disconnected() {
    this.stopListening();
  },
});
